export default __webpack_public_path__ + "static/media/match_illustration_tile_cover.0f563729.png";